module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ModelNameEdit"
    }
  }, [_vm._v("Model Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.nodeName),
      expression: "value.nodeName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "ModelNameEdit",
      "required": "",
      "placeholder": "Enter model node name",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.value.nodeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "nodeName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "numTimePointsEdit"
    }
  }, [_vm._v("Number of Timepoints")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.numTimePoints),
      expression: "value.numTimePoints"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "timePoints",
      "id": "numTimePointsEdit",
      "placeholder": "Enter number of timepoints"
    },
    domProps: {
      "value": (_vm.value.numTimePoints)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "numTimePoints", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "startTimePointEdit"
    }
  }, [_vm._v("Start Timepoint (year)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.startTimePoint),
      expression: "value.startTimePoint"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "startTimePoint",
      "id": "startTimePointEdit",
      "placeholder": "Enter start timepoint"
    },
    domProps: {
      "value": (_vm.value.startTimePoint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "startTimePoint", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "numSubTimePointsEdit"
    }
  }, [_vm._v("Number of Sub-timepoints")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.numSubTimes),
      expression: "value.numSubTimes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "subTimePoints",
      "id": "numSubTimePointsEdit",
      "placeholder": "Enter number of sub-timepoints"
    },
    domProps: {
      "value": (_vm.value.numSubTimes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "numSubTimes", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "numStatesEdit"
    }
  }, [_vm._v("Number of Model States")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.numStates),
      expression: "value.numStates"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "1",
      "name": "states",
      "id": "numStatesEdit",
      "disabled": "",
      "placeholder": "Enter number of model states"
    },
    domProps: {
      "value": (_vm.value.numStates)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "numStates", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onOkClick
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2604767a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2604767a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/create-model-node-dialog/create-model-node-dialog.vue.html
// module id = 1085
// module chunks = 0